import {pressReleaseLayout} from '@press-release-ui/press-release-layout';
import {pressReleaseBody} from '@press-release-ui/press-release-body';
import {pressReleaseCap} from '@press-release-ui/press-release-cap';
import {mediaUserOnlyInfo} from '@press-release-ui/media-user-only-info';
import type {PressReleasePreview} from '@openapi/press-release';
import {colors} from '@prtimes-basis/unfixed-new-ui/tokens';
import type {PreviewDeviceType} from '../../hooks/use-preview-device-state';
import {renderLinkifiedText} from '../../lib/render-linkified-text';
import {useApplyTableAnimationEffect} from './effects/use-apply-table-animation-effect';
import {useDecoratePixtaEffect} from './effects/use-decorate-pixta-effect';
import styles from './mail-preview.module.css';

type Props = {
  readonly device: PreviewDeviceType;
  readonly pressRelease: PressReleasePreview;
};

export function MailPreview({device, pressRelease}: Props) {
  const isOldRelease = pressRelease.editorVersion === null;
  useApplyTableAnimationEffect(isOldRelease);

  useDecoratePixtaEffect();

  const rootStyle = {
    backgroundColor: colors.white,
    ...(device === 'mobile'
      ? {marginInline: 'auto', width: '390px'}
      : {paddingTop: '22px'}),
  };

  return (
    <div className={styles.container}>
      <pressReleaseLayout.root
        version={pressRelease.editorVersion ?? '2015'}
        style={rootStyle}
      >
        <pressReleaseLayout.main>
          <pressReleaseLayout.pressReleaseBox device={device}>
            <pressReleaseCap.root>
              <pressReleaseCap.titles>
                <pressReleaseCap.title title={pressRelease.title} />
                <pressReleaseCap.subtitle>
                  {renderLinkifiedText(pressRelease.subtitle)}
                </pressReleaseCap.subtitle>
              </pressReleaseCap.titles>
            </pressReleaseCap.root>
            <pressReleaseLayout.pressReleaseMain>
              <pressReleaseBody.root>
                {pressRelease.releaseTargetFlgMediaOnly && (
                  <pressReleaseBody.mediaUserOnlyNotice />
                )}
                {pressRelease.head !== '' && (
                  <pressReleaseBody.leadParagraph>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{__html: pressRelease.head}}
                    />
                  </pressReleaseBody.leadParagraph>
                )}
                <table
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{__html: pressRelease.mailText}}
                >
                  {/* HACK: コメントアウトを追加するとwai-ariaエラーがなくなる
                    FIXME: テーブルの中身がtr,tdない場合にwai-ariaエラーが出るため、コメントアウトしている */}
                </table>
                {pressRelease.mediaUserOnlyInfo !== null && (
                  <mediaUserOnlyInfo.root>
                    {!pressRelease.releaseTargetFlgMediaOnly && (
                      <mediaUserOnlyInfo.notice />
                    )}
                    <mediaUserOnlyInfo.content>
                      {renderLinkifiedText(pressRelease.mediaUserOnlyInfo)}
                    </mediaUserOnlyInfo.content>
                  </mediaUserOnlyInfo.root>
                )}
              </pressReleaseBody.root>
            </pressReleaseLayout.pressReleaseMain>
          </pressReleaseLayout.pressReleaseBox>
        </pressReleaseLayout.main>
      </pressReleaseLayout.root>
    </div>
  );
}
